/**
 * Track custom events using the global gtag function
 * @param {string} eventName - The name of the event to track
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  // Only track in production
  if (import.meta.env.VITE_APP_ENV === "production" && window.gtag) {
    window.gtag("event", eventName, eventParams);
  } else {
    // Enhanced logging for development
    console.log(
      "%c🔍 Analytics Event (DEV)",
      "background: #4CAF50; color: white; padding: 2px 5px; border-radius: 3px;",
      "\nEvent:",
      eventName,
      "\nParams:",
      eventParams
    );
  }
};

/**
 * Track page views
 * @param {string} path - The page path
 * @param {string} title - The page title
 */
export const trackPageView = (path, title) => {
  if (import.meta.env.VITE_APP_ENV === "production" && window.gtag) {
    window.gtag("config", import.meta.env.VITE_GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  } else {
    console.log("Page View (DEV):", { path, title });
  }
};
